import React, { useState, useContext } from 'react'
import {
  getCourseCardDetails,
  getSessionDetails,
  getCategoryListMap,
} from '../../helpers/courseCardHelper'
import { getTeacherCardDetails } from 'src/consumer/helpers/teacherCardHelper'
import { useFetch } from '../../services/index'
import Player from '../Player'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { CongratulatoryCardContext } from 'src/consumer/context/CongraulatoryCardContext'

export default function CoursePlayer({ userFavoriteData }) {
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const { congratulatoryCardData, setCongratulatoryCardData } =
    useContext(CongratulatoryCardContext)
  const { selectedCard, showPlayer, ...restPlayerData } = playerData
  const { setupData } = useContext(SetupContext)
  const [ongoingSession, setOngoingSession] = useState(selectedCard?.sessionIndex || 0)
  const { courseTitle, courseId, courseType, courseLongDescription } =
    getCourseCardDetails(selectedCard)
  const { selectedSessionId, sessionsList } = getSessionDetails(selectedCard, ongoingSession)
  const { teacherTitle, teacherImage } = getTeacherCardDetails(selectedCard)
  const playerType =
    getCategoryListMap(setupData).get(selectedCard?.course?.category?.[0])?.playerType || 'regular'
  const { loading, data, error } = useFetch(
    `/api/secure/courses/${courseId}/sessions/${selectedSessionId}`,
    playerData?.otherData?.planId ? `&planId=${playerData?.otherData?.planId}` : '',
    'web',
  )
  //const signedURL = getCourseURLs(data);
  const signedURL = [
    data?.preparatory,
    data?.preInstructions,
    data?.meditate,
    data?.postInstructions,
  ]

  return (
    <Player
      signedURL={signedURL}
      teacherImage={teacherImage}
      teacherTitle={teacherTitle}
      courseTitle={courseTitle}
      courseLongDescription={courseLongDescription}
      loading={loading}
      courseType={courseType} //may be audio or video
      showPlayer={showPlayer}
      ongoingSession={ongoingSession}
      setOngoingSession={setOngoingSession}
      sessionsList={sessionsList}
      sessionId={selectedSessionId}
      afterRatingFunction={restPlayerData?.afterRatingFunction}
      courseId={courseId}
      playerType={playerType} // may be regular or looped_clock
      userFavoriteData={userFavoriteData}
      playerData={playerData}
      setPlayerData={setPlayerData}
      congratulatoryCardData={congratulatoryCardData}
      setCongratulatoryCardData={setCongratulatoryCardData}
    />
    // <UpcomingSessions>

    // </UpcomingSessions>
  )
}

export function CoursePlayerIsolated({ playerData, setPlayerData }) {
  const { congratulatoryCardData, setCongratulatoryCardData } = useState()
  const { selectedCard, showPlayer, ...restPlayerData } = playerData
  const { setupData } = useContext(SetupContext)
  const [ongoingSession, setOngoingSession] = useState(selectedCard?.sessionIndex || 0)
  const { courseTitle, courseId, courseType, courseLongDescription } =
    getCourseCardDetails(selectedCard)
  const { selectedSessionId, sessionsList } = getSessionDetails(selectedCard, ongoingSession)
  const { teacherTitle, teacherImage } = getTeacherCardDetails(selectedCard)
  const playerType =
    getCategoryListMap(setupData).get(selectedCard?.course?.category?.[0])?.playerType || 'regular'
  const { loading, data, error } = useFetch(
    `/api/secure/courses/${courseId}/sessions/${selectedSessionId}`,
    playerData?.otherData?.planId ? `&planId=${playerData?.otherData?.planId}` : '',
    'web',
  )
  //const signedURL = getCourseURLs(data);
  const signedURL = [
    data?.preparatory,
    data?.preInstructions,
    data?.meditate,
    data?.postInstructions,
  ]

  return (
    <Player
      signedURL={signedURL}
      teacherImage={teacherImage}
      teacherTitle={teacherTitle}
      courseTitle={courseTitle}
      courseLongDescription={courseLongDescription}
      loading={loading}
      courseType={courseType} //may be audio or video
      showPlayer={showPlayer}
      ongoingSession={ongoingSession}
      setOngoingSession={setOngoingSession}
      sessionsList={sessionsList}
      sessionId={selectedSessionId}
      afterRatingFunction={restPlayerData?.afterRatingFunction}
      courseId={courseId}
      playerType={playerType} // may be regular or looped_clock
      userFavoriteData={{}}
      playerData={playerData}
      setPlayerData={setPlayerData}
      congratulatoryCardData={congratulatoryCardData}
      setCongratulatoryCardData={setCongratulatoryCardData}
    />
    // <UpcomingSessions>

    // </UpcomingSessions>
  )
}
export function CoursePlayerStandAlone({ playerData, setPlayerData, setupData }) {
  const { congratulatoryCardData, setCongratulatoryCardData } = useState()
  const { selectedCard, showPlayer, ...restPlayerData } = playerData
  const [ongoingSession, setOngoingSession] = useState(selectedCard?.sessionIndex || 0)
  const { courseTitle, courseId, courseType, courseLongDescription } =
    getCourseCardDetails(selectedCard)
  const { selectedSessionId, sessionsList } = getSessionDetails(selectedCard, ongoingSession)
  const { teacherTitle, teacherImage } = getTeacherCardDetails(selectedCard)
  const playerType =
    getCategoryListMap(setupData).get(selectedCard?.course?.category?.[0])?.playerType || 'regular'
  const { loading, data, error } = useFetch(
    `/api/secure/courses/${courseId}/sessions/${selectedSessionId}`,
    playerData?.otherData?.planId ? `&planId=${playerData?.otherData?.planId}` : '',
    'web',
  )
  //const signedURL = getCourseURLs(data);
  const signedURL = [
    data?.preparatory,
    data?.preInstructions,
    data?.meditate,
    data?.postInstructions,
  ]

  return (
    <Player
      signedURL={signedURL}
      teacherImage={teacherImage}
      teacherTitle={teacherTitle}
      courseTitle={courseTitle}
      courseLongDescription={courseLongDescription}
      loading={loading}
      courseType={courseType} //may be audio or video
      showPlayer={showPlayer}
      ongoingSession={ongoingSession}
      setOngoingSession={setOngoingSession}
      sessionsList={sessionsList}
      sessionId={selectedSessionId}
      afterRatingFunction={restPlayerData?.afterRatingFunction}
      courseId={courseId}
      playerType={playerType} // may be regular or looped_clock
      userFavoriteData={{}}
      playerData={playerData}
      setPlayerData={setPlayerData}
      congratulatoryCardData={congratulatoryCardData}
      setCongratulatoryCardData={setCongratulatoryCardData}
    />
    // <UpcomingSessions>

    // </UpcomingSessions>
  )
}
